var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoundOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.528,
    height: 16.676,
    viewBox: "0 0 22.528 16.676",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.535 -9.67)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.145,10.23a1.089,1.089,0,0,0-.485-.113,1.127,1.127,0,0,0-.7.246l-4.584,3.7H5.66a1.128,1.128,0,0,0-1.125,1.125v5.625A1.128,1.128,0,0,0,5.66,21.938H9.373l4.584,3.691a1.142,1.142,0,0,0,.7.246,1.089,1.089,0,0,0,.485-.112,1.125,1.125,0,0,0,.64-1.013V11.25A1.127,1.127,0,0,0,15.145,10.23Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.063,18h0a11.42,11.42,0,0,0-3.291-8.079.845.845,0,1,0-1.2,1.188,9.761,9.761,0,0,1,2.805,6.9h0a9.761,9.761,0,0,1-2.805,6.9.847.847,0,0,0,.6,1.441.825.825,0,0,0,.6-.253A11.484,11.484,0,0,0,27.063,18Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.215,12.832a.845.845,0,1,0-1.2,1.188A5.627,5.627,0,0,1,20.63,18h0a5.651,5.651,0,0,1-1.617,3.98.847.847,0,0,0,.6,1.441.825.825,0,0,0,.6-.253,7.3,7.3,0,0,0,2.1-5.161h0A7.283,7.283,0,0,0,20.215,12.832Z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundOn);
export default __webpack_public_path__ + "static/media/sound-on.7c73aede4634d2a6989e029135f144c8.svg";
export { ForwardRef as ReactComponent };